var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.673,
    height: 20.821,
    viewBox: "0 0 9.673 20.821",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4036",
    "data-name": "Path 4036",
    d: "M394.6,224.374V234.44a.262.262,0,0,0,.262.262H398.6a.262.262,0,0,0,.262-.262v-10.23h2.71a.262.262,0,0,0,.261-.24l.261-3.083a.263.263,0,0,0-.262-.284h-2.971v-2.187a.928.928,0,0,1,.928-.928h2.089a.262.262,0,0,0,.262-.262v-3.082a.262.262,0,0,0-.262-.262h-3.529a3.75,3.75,0,0,0-3.75,3.75V220.6h-1.869a.262.262,0,0,0-.262.262v3.083a.262.262,0,0,0,.262.262H394.6Z",
    transform: "translate(-392.472 -213.881)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbWhite);
export default __webpack_public_path__ + "static/media/fb-white.2a7dfabfc6d7f3a7008857f8eef5ae52.svg";
export { ForwardRef as ReactComponent };